/**
 * Privacy & cookie policy text (TR + EN).
 * Rendered by src/pages/PrivacyPolicy.jsx and by scripts/prerender.js (static HTML for crawlers),
 * so edit the text here only. CommonJS so the Node prerender script can require() it.
 *
 * Block types:
 *   { p: 'text' }                      paragraph
 *   { lines: ['a', 'b'] }              one paragraph, one line each
 *   { ul: [['Label', 'text'], 'text'] } list; a [label, text] item renders the label in bold
 *   { table: { head: [..], rows: [[..]] } }
 * The e-mail address in any text becomes a mailto: link.
 */

const EMAIL = 'info@powerlab.works';

const privacy = {
  tr: {
    lang: 'tr',
    path: '/tr/gizlilik',
    altPath: '/en/privacy',
    altLabel: 'English version',
    title: 'Gizlilik ve Çerez Politikası',
    updated: 'Son güncelleme: 4 Kasım 2026',
    intro: [
      'Bu politika, powerlab.works web sitesini ve bayi portalını kullandığınızda, bizimle telefon, WhatsApp veya e-posta ile iletişime geçtiğinizde kişisel verilerinizi nasıl işlediğimizi açıklar. 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve AB Genel Veri Koruma Tüzüğü (GDPR) kapsamında hazırlanmıştır.',
    ],
    sections: [
      {
        h: '1. Veri sorumlusu',
        blocks: [
          { lines: ['Powerlab Works OÜ', 'Sicil kodu: 14811825', 'Adres: Sakala 7-2, 10141 Tallinn, Estonya', `E-posta: ${EMAIL}`] },
          { p: 'Türkiye iletişim noktası: Powerlab Works HQ Türkiye, Kazımdirik Mah. 283. Sk. No:3/A, 35100 Bornova / İzmir — Tel/WhatsApp: +90 532 786 66 35' },
        ],
      },
      {
        h: '2. Hangi verileri işliyoruz?',
        blocks: [
          { ul: [
            ['İletişim verileri', 'Ad-soyad, telefon numarası, e-posta adresi, WhatsApp/telefon/e-posta yazışmalarınızın içeriği.'],
            ['Araç verileri', 'Araç markası, modeli, motor bilgisi, şasi numarası (talep ederseniz) ve aracınıza ait ECU yazılım dosyaları.'],
            ['Bayi portalı verileri', 'Firma adı, yetkili kişi adı, e-posta, ülke, adres, vergi/KDV numarası, yüklenen ve teslim edilen dosyalar, sipariş, fatura ve ödeme kayıtları.'],
            ['Teknik veriler', 'IP adresi, tarayıcı ve cihaz bilgisi, sunucu kayıtları.'],
            ['Çerez verileri', 'Yalnızca izin verirseniz reklam ölçüm çerezleri (bkz. Bölüm 5).'],
          ] },
          { p: 'Kart bilgileriniz bize ulaşmaz; online ödemeler doğrudan PayPal veya Stripe üzerinden yapılır.' },
        ],
      },
      {
        h: '3. Verileri hangi amaçla ve hangi hukuki sebeple işliyoruz?',
        blocks: [
          { table: {
            head: ['Amaç', 'Hukuki sebep'],
            rows: [
              ['Talebinize yanıt vermek, randevu ve fiyat bilgisi sunmak, hizmeti yerine getirmek', 'Sözleşmenin kurulması/ifası (KVKK m.5/2-c; GDPR m.6/1-b)'],
              ['Faturalama, muhasebe ve vergi yükümlülükleri', 'Hukuki yükümlülük (KVKK m.5/2-ç; GDPR m.6/1-c)'],
              ['Site ve portal güvenliği, kötüye kullanımın önlenmesi', 'Meşru menfaat (KVKK m.5/2-f; GDPR m.6/1-f)'],
              ['Reklamlarımızın etkisini ölçmek (Google Ads)', 'Açık rıza / onay (KVKK m.5/1; GDPR m.6/1-a)'],
            ],
          } },
        ],
      },
      {
        h: '4. Verileri kimlerle paylaşıyoruz?',
        blocks: [
          { p: 'Verilerinizi satmayız. Yalnızca hizmeti sunmak için gerekli olan hizmet sağlayıcılarla paylaşırız:' },
          { ul: [
            'Sunucu/barındırma hizmeti sağlayıcımız',
            'Google (Google Ads reklam ölçümü — yalnızca onay verirseniz)',
            'Meta (WhatsApp üzerinden yazışma)',
            'PayPal ve Stripe (online ödemeler)',
            'GoDaddy (kurumsal e-posta)',
            'SimplBooks (faturalama ve muhasebe)',
            'Yasal olarak yetkili kamu kurumları (talep halinde)',
          ] },
          { p: "Bu sağlayıcıların bir kısmı yurt dışında (AB ve ABD) bulunmaktadır. Yurt dışına aktarımlar KVKK m.9 ve GDPR'ın ilgili hükümleri çerçevesinde (standart sözleşmeler ve gerektiğinde açık rızanız ile) yapılır." },
        ],
      },
      {
        h: '5. Çerezler',
        blocks: [
          { ul: [
            ['Zorunlu tercih kaydı', 'Çerez tercihinizi hatırlamak için tarayıcınızda pl_consent adlı bir kayıt tutulur. Site bunsuz tercihinizi hatırlayamaz.'],
            ['Reklam ölçüm çerezleri (Google Ads)', 'Yalnızca çerez bandında "Kabul et" derseniz etkinleşir. Reddederseniz Google\'ın Consent Mode özelliği ile reklam çerezleri yazılmaz.'],
          ] },
          { p: 'Tercihinizi istediğiniz zaman sayfanın altındaki "Çerez ayarları" bağlantısından değiştirebilirsiniz. Tarayıcınızın ayarlarından da çerezleri silebilir veya engelleyebilirsiniz.' },
        ],
      },
      {
        h: '6. Ne kadar süre saklıyoruz?',
        blocks: [
          { ul: [
            ['İletişim yazışmaları', 'Talebiniz sonuçlandıktan sonra en fazla 2 yıl.'],
            ['Yüklenen ve teslim edilen ECU dosyaları', 'En fazla 2 yıl; sonra silinir.'],
            ['Fatura ve muhasebe kayıtları', 'Estonya muhasebe mevzuatı gereği 7 yıl.'],
            ['Çerez tercihi', 'Siz silene veya değiştirene kadar tarayıcınızda.'],
          ] },
        ],
      },
      {
        h: '7. Haklarınız',
        blocks: [
          { p: 'KVKK m.11 ve GDPR kapsamında şu haklara sahipsiniz: verilerinizin işlenip işlenmediğini öğrenme, bilgi talep etme, işlenme amacını öğrenme, aktarıldığı kişileri bilme, eksik veya yanlış verilerin düzeltilmesini, silinmesini veya yok edilmesini isteme, itiraz etme, verilerinizin taşınmasını isteme, verdiğiniz onayı geri alma ve zararın giderilmesini talep etme.' },
          { p: `Başvurularınızı ${EMAIL} adresine iletebilirsiniz; en geç 30 gün içinde yanıt veririz. Ayrıca Kişisel Verileri Koruma Kurulu'na veya Estonya Veri Koruma Kurumu'na (Andmekaitse Inspektsioon) şikâyette bulunabilirsiniz.` },
        ],
      },
      {
        h: '8. Değişiklikler',
        blocks: [
          { p: 'Bu politikayı gerektiğinde güncelleyebiliriz. Güncel sürüm her zaman bu sayfada yayınlanır.' },
        ],
      },
    ],
  },

  en: {
    lang: 'en',
    path: '/en/privacy',
    altPath: '/tr/gizlilik',
    altLabel: 'Türkçe versiyon',
    title: 'Privacy & Cookie Policy',
    updated: 'Last updated: 4 November 2026',
    intro: [
      'This policy explains how we process your personal data when you use the powerlab.works website and dealer portal, or contact us by phone, WhatsApp or e-mail. It is prepared under the EU General Data Protection Regulation (GDPR) and Turkish Personal Data Protection Law No. 6698 (KVKK).',
    ],
    sections: [
      {
        h: '1. Data controller',
        blocks: [
          { lines: ['Powerlab Works OÜ', 'Registry code: 14811825', 'Address: Sakala 7-2, 10141 Tallinn, Estonia', `E-mail: ${EMAIL}`] },
          { p: 'Turkey contact point: Powerlab Works HQ Türkiye, Kazımdirik Mah. 283. Sk. No:3/A, 35100 Bornova / İzmir — Phone/WhatsApp: +90 532 786 66 35' },
        ],
      },
      {
        h: '2. What data we process',
        blocks: [
          { ul: [
            ['Contact data', 'Name, phone number, e-mail address and the content of your WhatsApp/phone/e-mail communication.'],
            ['Vehicle data', 'Make, model, engine details, VIN (if you provide it) and ECU software files of your vehicle.'],
            ['Dealer portal data', 'Company name, contact person, e-mail, country, address, tax/VAT number, uploaded and delivered files, order, invoice and payment records.'],
            ['Technical data', 'IP address, browser and device information, server logs.'],
            ['Cookie data', 'Advertising measurement cookies only if you consent (see Section 5).'],
          ] },
          { p: 'We never receive your card details; online payments are processed directly by PayPal or Stripe.' },
        ],
      },
      {
        h: '3. Purposes and legal bases',
        blocks: [
          { table: {
            head: ['Purpose', 'Legal basis'],
            rows: [
              ['Answering your request, giving quotes, delivering our services', 'Performance of a contract (GDPR Art. 6(1)(b))'],
              ['Invoicing, accounting and tax obligations', 'Legal obligation (GDPR Art. 6(1)(c))'],
              ['Security of the website and portal, preventing abuse', 'Legitimate interest (GDPR Art. 6(1)(f))'],
              ['Measuring the effect of our ads (Google Ads)', 'Consent (GDPR Art. 6(1)(a))'],
            ],
          } },
        ],
      },
      {
        h: '4. Who we share data with',
        blocks: [
          { p: 'We do not sell your data. We only share it with service providers needed to run our services:' },
          { ul: [
            'Our server/hosting provider',
            'Google (Google Ads measurement — only with your consent)',
            'Meta (WhatsApp messaging)',
            'PayPal and Stripe (online payments)',
            'GoDaddy (business e-mail)',
            'SimplBooks (invoicing and accounting)',
            'Public authorities where legally required',
          ] },
          { p: "Some of these providers are located outside the EEA (e.g. in the USA). Such transfers are based on the European Commission's Standard Contractual Clauses or other safeguards permitted by GDPR." },
        ],
      },
      {
        h: '5. Cookies',
        blocks: [
          { ul: [
            ['Strictly necessary preference record', 'We store a pl_consent entry in your browser to remember your cookie choice.'],
            ['Advertising measurement (Google Ads)', 'Only activated if you click "Accept" in the cookie banner. If you reject, Google Consent Mode ensures no advertising cookies are set.'],
          ] },
          { p: 'You can change your choice at any time via the "Cookie settings" link at the bottom of every page, or delete/block cookies in your browser settings.' },
        ],
      },
      {
        h: '6. How long we keep data',
        blocks: [
          { ul: [
            ['Communication records', 'up to 2 years after your request is completed.'],
            ['Uploaded and delivered ECU files', 'up to 2 years, then deleted.'],
            ['Invoices and accounting records', '7 years, as required by Estonian accounting law.'],
            ['Cookie preference', 'in your browser until you delete or change it.'],
          ] },
        ],
      },
      {
        h: '7. Your rights',
        blocks: [
          { p: 'Under GDPR you have the right to access, rectify and erase your data, to restrict or object to processing, to data portability, and to withdraw your consent at any time (without affecting prior processing).' },
          { p: `Send your requests to ${EMAIL}; we reply within 30 days. You may also lodge a complaint with the Estonian Data Protection Inspectorate (Andmekaitse Inspektsioon) or your local supervisory authority.` },
        ],
      },
      {
        h: '8. Changes',
        blocks: [
          { p: 'We may update this policy when needed. The current version is always published on this page.' },
        ],
      },
    ],
  },
};

module.exports = { privacy, EMAIL };
